import React from 'react';
import { motion } from 'framer-motion';
import { Globe2 } from 'lucide-react';
import { AnimatedCounter } from './AnimatedCounter';
const stats = [{
  value: 4000,
  suffix: '+',
  separator: true,
  label: 'Alumnos certificados'
}, {
  value: 10,
  suffix: '+',
  label: 'Años formando buzos'
}, {
  value: 12,
  suffix: '+',
  label: 'Viajes internacionales organizados cada año'
}, {
  value: 100,
  suffix: '%',
  label: 'Equipamiento incluido y material oficial PADI'
}];
export function Hero() {
  return <section className="relative min-h-screen w-full flex items-center justify-center pt-44 sm:pt-72 md:pt-52 pb-16 sm:pb-20 px-6 overflow-hidden" data-id="element-205">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-206">
        <img src="https://cdn.magicpatterns.com/uploads/9S3KDX98qZpmk5ZJq96g3k/OPCION_HERO_NUMERO_3.jpg" alt="Instructor de buceo enseñando paso a paso a una alumna principiante en la pileta" className="w-full h-full object-cover object-[center_42%]" data-id="element-207" />
        {/* Premium dark-navy overlay (Bonaire-style) */}
        <div className="absolute inset-0 bg-brand-background/80 mix-blend-multiply" data-id="element-208"></div>
        {/* Top & bottom fade so the brand block and content read perfectly */}
        <div className="absolute inset-0 bg-gradient-to-b from-brand-background/90 via-brand-background/40 to-brand-background" data-id="element-209"></div>
        {/* Edge vignette: darken borders, keep the instructor-student interaction in the center visible */}
        <div className="absolute inset-0 [background:radial-gradient(120%_90%_at_50%_45%,transparent_0%,transparent_38%,rgba(3,29,51,0.75)_100%)]" data-id="element-210"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-211">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-brand-primary/50 bg-brand-primary/10 backdrop-blur-sm mb-3 sm:mb-5" data-id="element-212">
          <Globe2 size={14} className="text-brand-primary" strokeWidth={2} data-id="element-213" />
          <span className="text-brand-primary text-xs font-bold tracking-widest uppercase" data-id="element-214">
            Buceá en cualquier parte del mundo
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex flex-col items-center mb-6 sm:mb-8" data-id="element-215">
          <h2 className="text-white font-heading font-black text-6xl sm:text-8xl md:text-9xl leading-none tracking-tight uppercase" data-id="element-216">
            PADI
          </h2>
          <h2 className="text-brand-primary font-heading font-black text-5xl sm:text-7xl md:text-8xl leading-none tracking-tight uppercase mt-[-0.2em]" data-id="element-217">
            OPEN WATER
          </h2>
          <h2 className="text-white font-heading font-black text-6xl sm:text-8xl md:text-9xl leading-none tracking-tight uppercase mt-[-0.1em]" data-id="element-218">
            DIVER
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="max-w-2xl mx-auto space-y-5 sm:space-y-6" data-id="element-219">
          <p className="text-white/90 text-xl sm:text-2xl font-light leading-relaxed" data-id="element-220">
            Tu certificación es solo el comienzo. Descubrí una nueva forma de
            viajar, explorar y vivir el océano.
          </p>

          <div className="w-full max-w-md mx-auto pt-1 sm:pt-2" data-id="element-221">
            <button onClick={() => document.getElementById('planes')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })} className="w-full bg-gradient-to-r from-[#00B8D9] to-[#4FC3F7] text-[#031D33] font-bold uppercase tracking-widest py-5 px-8 rounded-full transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_10px_30px_-5px_rgba(0,184,217,0.45)] hover:shadow-[0_14px_36px_-4px_rgba(79,195,247,0.55)]" data-id="element-222">
              Quiero comenzar mi aventura
            </button>
          </div>

          <div className="pt-4 sm:pt-6" data-id="element-223">
            <p className="text-brand-primary font-bold uppercase tracking-widest text-sm sm:text-base mb-6" data-id="element-224">
              Formación oficial organizada por Buceo y Navegación
            </p>

            <div className="grid grid-cols-2 gap-3 sm:gap-4 max-w-xl mx-auto" data-id="element-225">
              {stats.map((stat, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-60px'
            }} transition={{
              duration: 0.5,
              delay: i * 0.1
            }} className="rounded-2xl border border-brand-primary/25 bg-brand-primary/5 backdrop-blur-sm px-4 py-5 sm:px-6 sm:py-6 flex flex-col items-center text-center" data-id="element-226">
                  <span className="text-brand-primary font-heading font-black text-4xl sm:text-5xl leading-none tracking-tight" data-id="element-227">
                    <AnimatedCounter value={stat.value} suffix={stat.suffix} separator={stat.separator} data-id="element-228" />
                  </span>
                  <span className="text-brand-details/90 text-xs sm:text-sm font-medium mt-2 leading-snug" data-id="element-229">
                    {stat.label}
                  </span>
                </motion.div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}